import React from 'react';

const FileZipIcon = () => {
	return (
		<svg
			width='24'
			height='30'
			viewBox='0 0 24 30'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M9.1875 14.0625C9.1875 13.5652 9.38504 13.0883 9.73668 12.7367C10.0883 12.385 10.5652 12.1875 11.0625 12.1875H12.9375C13.4348 12.1875 13.9117 12.385 14.2633 12.7367C14.615 13.0883 14.8125 13.5652 14.8125 14.0625V15.8212L15.5625 18.8194C15.6559 19.1945 15.6312 19.5893 15.4915 19.9498C15.3519 20.3103 15.1042 20.6188 14.7825 20.8331L13.0387 21.9956C12.7308 22.2008 12.3691 22.3103 11.9991 22.3103C11.629 22.3103 11.2673 22.2008 10.9594 21.9956L9.21562 20.8331C8.89421 20.6186 8.64695 20.3099 8.50766 19.9495C8.36837 19.589 8.34387 19.1943 8.4375 18.8194L9.1875 15.8212V14.0625ZM12.9375 14.0625H11.0625V15.8212C11.0625 15.9749 11.0436 16.1279 11.0062 16.2769L10.2563 19.2731L12 20.4356L13.7438 19.2731L12.9937 16.2769C12.9564 16.1279 12.9375 15.9749 12.9375 15.8212V14.0625Z'
				fill='#05386B'
			/>
			<path
				d='M0.75 3.75C0.75 2.75544 1.14509 1.80161 1.84835 1.09835C2.55161 0.395088 3.50544 0 4.5 0H19.5C20.4946 0 21.4484 0.395088 22.1516 1.09835C22.8549 1.80161 23.25 2.75544 23.25 3.75V26.25C23.25 27.2446 22.8549 28.1984 22.1516 28.9016C21.4484 29.6049 20.4946 30 19.5 30H4.5C3.50544 30 2.55161 29.6049 1.84835 28.9016C1.14509 28.1984 0.75 27.2446 0.75 26.25V3.75ZM11.0625 1.875H4.5C4.00272 1.875 3.52581 2.07254 3.17417 2.42417C2.82254 2.77581 2.625 3.25272 2.625 3.75V26.25C2.625 26.7473 2.82254 27.2242 3.17417 27.5758C3.52581 27.9275 4.00272 28.125 4.5 28.125H19.5C19.9973 28.125 20.4742 27.9275 20.8258 27.5758C21.1775 27.2242 21.375 26.7473 21.375 26.25V3.75C21.375 3.25272 21.1775 2.77581 20.8258 2.42417C20.4742 2.07254 19.9973 1.875 19.5 1.875H13.875V3.75H12V5.625H13.875V7.5H12V9.375H13.875V11.25H11.0625V9.375H9.1875V7.5H11.0625V5.625H9.1875V3.75H11.0625V1.875Z'
				fill='#05386B'
			/>
		</svg>
	);
};

export default FileZipIcon;
